import DocumentCard from "@components/DocumentCard/DocumentCard";
import CustomFormLabel from "@components/FormItem/FormItem.styles";
import SideDrawer from "@components/SimpleSideDrawer/SideDrawer";
import { translateNormalizedRole } from "@utils/roles";
import { useTranslation } from "react-i18next";
import { useDownloadCertificate } from "../hooks/useDownloadCertificate";
import { LANG_BASE, service, TEST_ID_BASE } from "../VesselStatus";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  delegatedBy?: string;
  delegatedByRole?: string;
  delegationReason?: string;
  attachment?: string;
  attachmentName?: string;
};

const DelegateDetailsSideDrawer = ({
  isOpen,
  onClose,
  delegationReason,
  delegatedBy,
  delegatedByRole,
  attachment,
  attachmentName,
}: Props) => {
  const { t } = useTranslation();
  const { handleDownload, handlePreview } = useDownloadCertificate();
  const delegatedByRoleText = translateNormalizedRole(t, delegatedByRole);

  return (
    <SideDrawer
      isOpen={isOpen}
      onClose={onClose}
      keepMounted={false}
      title={t(`${LANG_BASE}.delegation-reason`)}
      hideCancelButton={true}
      submitLabel={t("common.ok")}
    >
      <div className="w-[400px] p-6">
        <div className="col-span-full mb-6 flex flex-col gap-2">
          <CustomFormLabel sx={{ fontSize: 16, fontWeight: 700 }} data-testid="labelId">
            {t(`${LANG_BASE}.delegation-details`)}
          </CustomFormLabel>
          <div
            className="text-sm whitespace-pre-wrap wrap-break-word"
            data-testid={`${TEST_ID_BASE}-static-content`}
          >
            {delegationReason || "-"}
          </div>
        </div>
        <div className="col-span-full mb-0 flex flex-col gap-2">
          <CustomFormLabel sx={{ fontSize: 16, fontWeight: 700 }} data-testid="labelId">
            {t(`${LANG_BASE}.attachments`)}
          </CustomFormLabel>
          {attachment && attachmentName ? (
            <DocumentCard
              data-testid={`${TEST_ID_BASE}-delegation-attachment`}
              documentName={attachmentName}
              fileName={""}
              onDownload={() => {
                handleDownload("document", service, attachment, attachmentName);
              }}
              onPreview={() => handlePreview("document", service, attachment)}
            />
          ) : (
            "-"
          )}
        </div>
        <div className="mt-4">
          <p className="text-xs text-gray-500">
            {t(`${LANG_BASE}.delegated-by`)}:&nbsp;
            {delegatedBy || delegatedByRoleText ? (
              <>
                {delegatedBy && <span className="text-gray-800">{delegatedBy}</span>}
                {delegatedBy && delegatedByRoleText ? " / " : null}
                {delegatedByRoleText}
              </>
            ) : (
              "-"
            )}
          </p>
        </div>
      </div>
    </SideDrawer>
  );
};

export default DelegateDetailsSideDrawer;
